import { render, staticRenderFns } from "./collection-item.vue?vue&type=template&id=041adf5b&scoped=true&"
import script from "./collection-item.vue?vue&type=script&lang=js&"
export * from "./collection-item.vue?vue&type=script&lang=js&"
import style0 from "./collection-item.vue?vue&type=style&index=0&id=041adf5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041adf5b",
  null
  
)

export default component.exports